export const MatchClutchDummyData = {
  apiPlayerDetectedShots: [
    {
      individualStats: [
        {
          resPartnerId: 72090,
          playerDetectedShotsList: [
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.708, 0.889]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.872, 0.796]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.763, 0.803]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.398, 0.881]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.866, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.710, 0.847]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.743, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.892, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.418, 0.887]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.838, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.810, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.609, 0.773]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.631, 0.683]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.820, 0.711]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.668, 0.689]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.400, 0.086]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.225, 0.251]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.249, 0.199]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.241, 0.317]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.421, 0.053]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.460, 0.081]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.279, 0.093]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.373, 0.212]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.354, 0.281]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.412, 0.277]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.350, 0.256]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.693, 0.090]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.326, 0.097]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.311, 0.276]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.474, 0.292]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.163, 0.274]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.674, 0.090]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.284, 0.111]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.146, 0.091]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.399, 0.318]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.415, 0.208]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.462, 0.066]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.491, 0.273]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.446, 0.255]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.283, 0.084]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.336, 0.105]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.178, 0.077]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.364, 0.278]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.442, 0.258]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.490, 0.051]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.136, 0.194]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.338, 0.131]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.345, 0.123]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.485, 0.342]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.335, 0.110]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.348, 0.243]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.390, 0.350]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.352, 0.139]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.407, 0.091]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.337, 0.293]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.350, 0.054]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.396, 0.068]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.312, 0.325]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.245, 0.037]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.339, 0.040]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.387, 0.091]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.628, 0.126]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.263, 0.098]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.363, 0.259]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.440, 0.255]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.368, 0.229]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.142, 0.105]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.300, 0.176]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.336, 0.078]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.355, 0.164]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.398, 0.252]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.440, 0.283]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.129, 0.127]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.184, 0.258]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.281, 0.328]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.393, 0.033]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.296, 0.060]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.459, 0.280]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.301, 0.276]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.355, 0.299]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.301, 0.260]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.186, 0.182]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.233, 0.071]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.363, 0.114]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.325, 0.308]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.168, 0.058]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.347, 0.164]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.324, 0.083]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.312, 0.088]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.447, 0.076]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.643, 0.077]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.323, 0.164]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.344, 0.263]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.475, 0.057]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.351, 0.123]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.341, 0.069]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.372, 0.305]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.379, 0.284]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.584, 0.888]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.675, 0.831]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.658, 0.888]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.816, 0.614]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.761, 0.661]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.792, 0.665]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.755, 0.729]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.630, 0.612]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.773, 0.697]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.699, 0.710]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.759, 0.691]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.652, 0.688]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.782, 0.833]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.775, 0.733]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.639, 0.694]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.442, 0.887]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.659, 0.868]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.624, 0.662]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.859, 0.618]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.688, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.726, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.640, 0.890]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.497, 0.884]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.646, 0.890]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.655, 0.759]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.889, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.779, 0.882]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.712, 0.771]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.341, 0.885]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.373, 0.883]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.878, 0.884]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.233, 0.886]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.669, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.694, 0.873]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.725, 0.793]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.674, 0.676]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.627, 0.673]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.660, 0.719]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.840, 0.890]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.857, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.807, 0.882]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.622, 0.888]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.831, 0.776]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.668, 0.602]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.775, 0.689]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.673, 0.728]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.794, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.733, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.738, 0.885]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.652, 0.764]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.572, 0.686]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.626, 0.642]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.767, 0.656]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.868, 0.776]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.737, 0.808]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.666, 0.728]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.614, 0.702]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.767, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.921, 0.888]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.748, 0.681]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.602, 0.703]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.623, 0.512]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.865, 0.883]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.826, 0.877]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.689, 0.710]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.341, 0.888]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.371, 0.884]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.784, 0.831]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.714, 0.674]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.637, 0.890]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.658, 0.744]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.241, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.327, 0.887]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.639, 0.890]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.712, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.699, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.495, 0.889]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.788, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.677, 0.814]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.870, 0.730]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.655, 0.706]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.531, 0.518]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.643, 0.807]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.597, 0.889]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.861, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.674, 0.693]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.874, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.849, 0.886]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.878, 0.767]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.766, 0.701]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.331, 0.887]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.815, 0.715]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.748, 0.890]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.773, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.740, 0.886]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.783, 0.881]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.325, 0.887]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.500, 0.865]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.615, 0.678]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.771, 0.889]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.593, 0.888]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.764, 0.890]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.847, 0.891]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.328, 0.885]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.717, 0.887]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.615, 0.850]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.813, 0.829]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.748, 0.887]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.757, 0.886]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.664, 0.726]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.899, 0.885]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.681, 0.740]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.706, 0.744]",
              zone: 2,
            },
          ],
        },
        {
          resPartnerId: 112965,
          playerDetectedShotsList: [
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.137, 0.082]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.190, 0.255]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.308, 0.093]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.417, 0.113]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.368, 0.212]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.421, 0.326]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.631, 0.130]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.368, 0.305]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.249, 0.267]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.436, 0.117]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.637, 0.118]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.444, 0.258]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.228, 0.261]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.306, 0.356]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.444, 0.108]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.288, 0.106]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.152, 0.082]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.373, 0.302]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.407, 0.067]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.131, 0.143]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.488, 0.061]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.186, 0.090]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.766, 0.863]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.850, 0.876]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.783, 0.657]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.887, 0.876]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.897, 0.873]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.656, 0.878]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.736, 0.879]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.902, 0.871]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.883, 0.749]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.800, 0.855]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.730, 0.877]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.632, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.918, 0.792]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.634, 0.875]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.663, 0.645]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.862, 0.869]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.413, 0.870]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.825, 0.722]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.638, 0.869]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.710, 0.864]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.832, 0.868]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.407, 0.872]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.820, 0.712]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.636, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.667, 0.688]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.794, 0.858]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.969, 0.846]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.854, 0.866]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.640, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.676, 0.800]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.614, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.292, 0.873]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.734, 0.622]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.867, 0.861]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.758, 0.856]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.951, 0.772]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.907, 0.678]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.677, 0.870]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.882, 0.775]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.805, 0.848]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.647, 0.634]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.704, 0.711]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.701, 0.644]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.882, 0.785]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.818, 0.667]",
              zone: 2,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.695, 0.686]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.812, 0.823]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.868, 0.874]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.711, 0.869]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.749, 0.879]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.897, 0.875]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.608, 0.867]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.638, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.831, 0.805]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.431, 0.870]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.812, 0.680]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.621, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.653, 0.875]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.806, 0.879]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.864, 0.854]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.771, 0.875]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.631, 0.875]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.789, 0.874]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.410, 0.870]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.603, 0.872]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.808, 0.869]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.793, 0.874]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.415, 0.869]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.741, 0.856]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.856, 0.854]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.737, 0.879]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.734, 0.878]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.951, 0.813]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.563, 0.625]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.695, 0.878]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.786, 0.852]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.725, 0.874]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.725, 0.741]",
              zone: 2,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.772, 0.653]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.910, 0.856]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.805, 0.862]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.711, 0.857]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.752, 0.853]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.905, 0.875]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.831, 0.875]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.788, 0.852]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.834, 0.851]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.417, 0.113]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.388, 0.296]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.387, 0.318]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.446, 0.112]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.366, 0.287]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.364, 0.155]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.146, 0.287]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.337, 0.361]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.211, 0.081]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.339, 0.148]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.626, 0.054]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.363, 0.101]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.412, 0.072]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.242, 0.037]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.339, 0.040]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.152, 0.212]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.121, 0.340]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.258, 0.026]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.256, 0.066]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.323, 0.074]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.203, 0.090]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.285, 0.060]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.258, 0.036]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.203, 0.162]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.345, 0.044]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.418, 0.265]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.378, 0.143]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.174, 0.091]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.213, 0.103]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.419, 0.350]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.236, 0.125]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.335, 0.263]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.209, 0.242]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.401, 0.100]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.391, 0.039]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.249, 0.036]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.125, 0.313]",
              zone: 2,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.145, 0.259]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.422, 0.271]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.255, 0.084]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.189, 0.178]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.218, 0.203]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.246, 0.031]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.437, 0.104]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.320, 0.220]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.240, 0.173]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.280, 0.098]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.212, 0.238]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.448, 0.103]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.486, 0.129]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.348, 0.275]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.683, 0.086]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.366, 0.159]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.259, 0.238]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.192, 0.081]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.461, 0.057]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.198, 0.095]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.142, 0.205]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.377, 0.096]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.172, 0.086]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.259, 0.080]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.310, 0.381]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.129, 0.175]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.243, 0.094]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.305, 0.213]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.387, 0.356]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.453, 0.320]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.204, 0.255]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.239, 0.042]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.201, 0.239]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.132, 0.466]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.132, 0.447]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.384, 0.139]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.237, 0.137]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.336, 0.064]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.323, 0.064]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.462, 0.129]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.467, 0.357]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.633, 0.130]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.234, 0.258]",
              zone: 2,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.251, 0.309]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.380, 0.139]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.413, 0.113]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.636, 0.096]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.448, 0.108]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.232, 0.076]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.252, 0.116]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.129, 0.163]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.189, 0.076]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.369, 0.100]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.261, 0.128]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.277, 0.132]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.362, 0.096]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.238, 0.158]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.365, 0.219]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.346, 0.348]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.386, 0.205]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.287, 0.362]",
              zone: 2,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.324, 0.319]",
              zone: 2,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.207, 0.081]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.241, 0.145]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.208, 0.090]",
              zone: 5,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.192, 0.095]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.255, 0.251]",
              zone: 2,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.179, 0.086]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.141, 0.082]",
              zone: 5,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.288, 0.065]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.117, 0.209]",
              zone: 5,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.367, 0.330]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.373, 0.338]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.381, 0.296]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.247, 0.085]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.638, 0.130]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.182, 0.274]",
              zone: 2,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.455, 0.108]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.226, 0.071]",
              zone: 5,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.183, 0.146]",
              zone: 5,
            },
          ],
        },
        {
          resPartnerId: 87607,
          playerDetectedShotsList: [
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.741, 0.276]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.643, 0.315]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.771, 0.088]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.852, 0.302]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.648, 0.170]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.694, 0.342]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.616, 0.219]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.772, 0.291]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.824, 0.246]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.633, 0.135]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.820, 0.131]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.695, 0.103]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.754, 0.314]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.972, 0.124]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.851, 0.194]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.946, 0.112]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.633, 0.068]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.908, 0.235]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.610, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.079, 0.883]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.623, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.627, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.403, 0.713]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.291, 0.873]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.109, 0.875]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.393, 0.677]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.154, 0.867]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.073, 0.868]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.248, 0.714]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.482, 0.632]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.356, 0.711]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.445, 0.663]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.342, 0.690]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.339, 0.684]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.096, 0.869]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.367, 0.855]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.087, 0.868]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.379, 0.637]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.070, 0.873]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.590, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.277, 0.653]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.481, 0.555]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.268, 0.871]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.636, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.614, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.270, 0.700]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.288, 0.870]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.352, 0.827]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.662, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.542, 0.885]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.325, 0.869]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.654, 0.882]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.602, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.630, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.098, 0.880]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.256, 0.881]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.305, 0.869]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.413, 0.779]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.290, 0.701]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.355, 0.868]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.309, 0.677]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.497, 0.743]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.088, 0.879]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.310, 0.884]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.370, 0.828]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.424, 0.626]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.371, 0.843]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.165, 0.666]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.331, 0.696]",
              zone: 0,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.510, 0.885]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.406, 0.630]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.397, 0.649]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.095, 0.867]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.249, 0.834]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.439, 0.711]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.285, 0.876]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.081, 0.873]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.181, 0.831]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.086, 0.868]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.516, 0.880]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.081, 0.870]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.279, 0.858]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.332, 0.792]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.608, 0.875]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.559, 0.770]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.294, 0.867]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.553, 0.749]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.612, 0.809]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.618, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.617, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.392, 0.748]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.311, 0.870]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.360, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.449, 0.884]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.423, 0.865]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.218, 0.629]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.399, 0.722]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.644, 0.878]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.774, 0.884]",
              zone: 5,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.458, 0.864]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.105, 0.869]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.112, 0.869]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.242, 0.845]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.328, 0.866]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.356, 0.871]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.795, 0.341]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.626, 0.259]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.662, 0.283]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.336, 0.045]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.499, 0.061]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.739, 0.352]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.761, 0.291]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.664, 0.307]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.765, 0.157]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.533, 0.157]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.931, 0.174]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.847, 0.109]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.740, 0.128]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.591, 0.269]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.789, 0.140]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.888, 0.117]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.750, 0.137]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.963, 0.177]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.881, 0.147]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.977, 0.184]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.452, 0.090]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.723, 0.334]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.792, 0.144]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.784, 0.148]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.469, 0.085]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.467, 0.085]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.808, 0.144]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.589, 0.123]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.838, 0.296]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.471, 0.066]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.471, 0.071]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.846, 0.222]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.715, 0.145]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.579, 0.223]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.706, 0.066]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.614, 0.100]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.698, 0.067]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.762, 0.224]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.715, 0.207]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.529, 0.161]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.903, 0.162]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.661, 0.304]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.895, 0.117]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.958, 0.150]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.922, 0.170]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.860, 0.147]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.871, 0.225]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.844, 0.078]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.583, 0.205]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.808, 0.176]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.515, 0.169]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.676, 0.158]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.723, 0.282]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.797, 0.237]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.410, 0.082]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.802, 0.110]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.525, 0.220]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.882, 0.139]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.477, 0.085]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.679, 0.298]",
              zone: 0,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.656, 0.147]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.745, 0.089]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.755, 0.056]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.835, 0.131]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.668, 0.072]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.858, 0.243]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.849, 0.208]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.717, 0.158]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.539, 0.230]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.918, 0.117]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.907, 0.130]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.768, 0.191]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.910, 0.090]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.889, 0.100]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.968, 0.157]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.784, 0.119]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.922, 0.104]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.885, 0.104]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.460, 0.085]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.484, 0.089]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.696, 0.207]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.714, 0.276]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.461, 0.125]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.792, 0.136]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.598, 0.049]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.434, 0.076]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.689, 0.112]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.951, 0.169]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.955, 0.173]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.794, 0.293]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.743, 0.141]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.585, 0.156]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.696, 0.196]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.444, 0.099]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.737, 0.279]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.926, 0.104]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.718, 0.294]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.824, 0.330]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.685, 0.387]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.779, 0.344]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.978, 0.137]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.789, 0.123]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.522, 0.234]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.541, 0.124]",
              zone: 4,
            },
          ],
        },
        {
          resPartnerId: 65934,
          playerDetectedShotsList: [
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.293, 0.788]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.444, 0.662]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.314, 0.830]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.151, 0.888]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.139, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.237, 0.776]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.135, 0.889]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.110, 0.885]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.207, 0.858]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.314, 0.815]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.316, 0.795]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.153, 0.706]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.401, 0.668]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.537, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.542, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.236, 0.812]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.266, 0.856]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.360, 0.800]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.373, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.435, 0.801]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.529, 0.878]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.375, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.380, 0.778]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.439, 0.820]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.530, 0.882]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.330, 0.802]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.775, 0.223]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.750, 0.192]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.843, 0.069]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.755, 0.300]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.775, 0.297]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.700, 0.264]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.684, 0.170]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.598, 0.171]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.711, 0.181]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.949, 0.099]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.784, 0.106]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.855, 0.054]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.551, 0.119]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.701, 0.146]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.738, 0.241]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.530, 0.124]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.714, 0.125]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.814, 0.287]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.769, 0.288]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.712, 0.133]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.695, 0.218]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.818, 0.092]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.600, 0.096]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.924, 0.108]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.832, 0.069]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.764, 0.247]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.741, 0.203]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.822, 0.287]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.772, 0.119]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.789, 0.191]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.978, 0.124]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.711, 0.315]",
              zone: 0,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.958, 0.103]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.797, 0.060]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.680, 0.125]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.572, 0.278]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.751, 0.379]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.761, 0.314]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.684, 0.342]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.818, 0.078]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.513, 0.257]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.823, 0.316]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.963, 0.112]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.686, 0.138]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.696, 0.242]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.645, 0.178]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.674, 0.301]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.572, 0.281]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.989, 0.128]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.532, 0.317]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.670, 0.309]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.955, 0.137]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.545, 0.123]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.707, 0.146]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.673, 0.225]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.686, 0.298]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.534, 0.074]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.396, 0.072]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.706, 0.112]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.673, 0.150]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.552, 0.110]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.641, 0.271]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.705, 0.166]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.718, 0.103]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.634, 0.232]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.653, 0.283]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.802, 0.281]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.743, 0.157]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.672, 0.228]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.795, 0.060]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.777, 0.153]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.787, 0.180]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.763, 0.199]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.822, 0.092]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.844, 0.092]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.419, 0.108]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.822, 0.140]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.772, 0.328]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.657, 0.315]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.658, 0.409]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.276, 0.864]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.265, 0.832]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.273, 0.819]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.334, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.295, 0.846]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.139, 0.888]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.390, 0.864]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.422, 0.813]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.541, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.095, 0.821]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.132, 0.859]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.450, 0.742]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.311, 0.879]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.327, 0.823]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.306, 0.704]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.541, 0.882]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.635, 0.863]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.539, 0.881]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.528, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.325, 0.763]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.198, 0.767]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.373, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.542, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.354, 0.793]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.332, 0.800]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.387, 0.775]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.551, 0.885]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.300, 0.807]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.490, 0.881]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.356, 0.877]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.512, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.323, 0.747]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.399, 0.730]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.209, 0.739]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.404, 0.707]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.554, 0.765]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.389, 0.790]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.367, 0.725]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.573, 0.744]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.383, 0.871]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.541, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.514, 0.883]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.297, 0.784]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.370, 0.652]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.094, 0.874]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.249, 0.814]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.152, 0.889]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.263, 0.787]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.199, 0.785]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.212, 0.882]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.355, 0.743]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.409, 0.681]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.470, 0.676]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.381, 0.654]",
              zone: 1,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.284, 0.869]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.168, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.341, 0.845]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.479, 0.758]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.093, 0.874]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.535, 0.879]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.380, 0.812]",
              zone: 4,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.303, 0.877]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.356, 0.871]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.365, 0.872]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.385, 0.779]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.162, 0.743]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.539, 0.878]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.438, 0.751]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.388, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.382, 0.739]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.265, 0.669]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.539, 0.880]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.297, 0.658]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.388, 0.665]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.355, 0.717]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.444, 0.710]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.244, 0.864]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.342, 0.774]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.099, 0.875]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.090, 0.874]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.091, 0.711]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.388, 0.601]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.315, 0.822]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.083, 0.688]",
              zone: 0,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.388, 0.704]",
              zone: 1,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.356, 0.703]",
              zone: 1,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.134, 0.885]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.175, 0.724]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.243, 0.790]",
              zone: 3,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.251, 0.722]",
              zone: 0,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.517, 0.883]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.126, 0.885]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.544, 0.880]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.313, 0.788]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.369, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.400, 0.868]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.386, 0.756]",
              zone: 4,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.532, 0.748]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.553, 0.882]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.402, 0.810]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.362, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.391, 0.872]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.378, 0.737]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.546, 0.883]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.531, 0.876]",
              zone: 4,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.338, 0.748]",
              zone: 1,
            },
            {
              shotLabel: "serve",
              shotDirection: "straight",
              normalizedCoordinates: "[0.388, 0.874]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.376, 0.749]",
              zone: 1,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.253, 0.802]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "unknown",
              normalizedCoordinates: "[0.313, 0.774]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.268, 0.683]",
              zone: 0,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.087, 0.873]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.382, 0.863]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.154, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.175, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "overhead",
              shotDirection: "straight",
              normalizedCoordinates: "[0.254, 0.678]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "straight",
              normalizedCoordinates: "[0.380, 0.639]",
              zone: 1,
            },
            {
              shotLabel: "overhead",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.330, 0.704]",
              zone: 0,
            },
            {
              shotLabel: "volley",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.320, 0.709]",
              zone: 0,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.556, 0.887]",
              zone: 4,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.823, 0.896]",
              zone: 5,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "straight",
              normalizedCoordinates: "[0.266, 0.887]",
              zone: 3,
            },
            {
              shotLabel: "lob",
              shotDirection: "straight",
              normalizedCoordinates: "[0.341, 0.887]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.275, 0.836]",
              zone: 3,
            },
            {
              shotLabel: "drive",
              shotDirection: "straight",
              normalizedCoordinates: "[0.085, 0.873]",
              zone: 3,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.400, 0.873]",
              zone: 4,
            },
            {
              shotLabel: "serve",
              shotDirection: "cross/left",
              normalizedCoordinates: "[0.543, 0.880]",
              zone: 4,
            },
            {
              shotLabel: "lob",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.105, 0.888]",
              zone: 3,
            },
            {
              shotLabel: "uncertain",
              shotDirection: "cross/right",
              normalizedCoordinates: "[0.343, 0.868]",
              zone: 4,
            },
          ],
        },
      ],
    },
  ],
  playerStatistics: [
    {
      resPartnerId: 87607,
      playerStatsDetails: [
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 91,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 660.22,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 3.98,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 136,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 1263.96,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 5.33,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 5.73,
        },
      ],
    },
    {
      resPartnerId: 65934,
      playerStatsDetails: [
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 5.93,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 171,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 857.03,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 85,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 628.55,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 6.3,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 9.94,
        },
      ],
    },
    {
      resPartnerId: 112965,
      playerStatsDetails: [
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 6.39,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 1.69,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 9.57,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 145,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 1092.82,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 10.23,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 18.47,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 97,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 585.8,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 10.71,
        },
      ],
    },
    {
      resPartnerId: 72090,
      playerStatsDetails: [
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 1,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 3.86,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 142,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 747.61,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 38.67,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 2,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 5.67,
        },
        {
          consistency: -1,
          attack: -1,
          physicality: -1,
          numberOfShots: 92,
          shotQuality: -1,
          clutchScore: -1,
          courtCoverage: -1,
          distanceRunMeters: 664.14,
        },
      ],
    },
  ],
  // matchStatsDetails: {
  //   matchTimeMinutes: 59.99,
  //   matchTimeInPlayMinutes: 18.59,
  //   avgRallyShots: 5.74,
  //   avgRallySeconds: 6.52,
  //   longestRallyShots: 24,
  //   longestRallySeconds: 28.97,
  // },
};
